import { render, staticRenderFns } from "./Specification.vue?vue&type=template&id=c559ba94&scoped=true&"
import script from "./Specification.vue?vue&type=script&lang=ts&"
export * from "./Specification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c559ba94",
  null
  
)

export default component.exports